module.exports = __webpack_public_path__ + "static/media/IntroMusic.64cc300b.mp3";